import de from './de.json'
import en from './en.json'
import es from './es.json'
import fr from './fr.json'
import hi from './hi-IN.json'
import id from './id.json'
import it from './it.json'
import ja from './ja.json'
import ko from './ko.json'
import nl from './nl.json'
import th from './th.json'
import zh from './zh.json'
import fa from './fa.json'
import tw from './zh-TW.json'
import vi from './vi.json'

export default {
  messages: {
    de: de,
    en: en,
    es: es,
    fr: fr,
    hi: hi,
    id: id,
    it: it,
    ja: ja,
    ko: ko,
    nl: nl,
    th: th,
    vi: vi,
    zh: zh,
    fa: fa,
    tw: tw
  }
}
